// extracted by mini-css-extract-plugin
export default {"container":"PkEa52","videoWithSidePanel":"NHS2TL","video":"V64eQW"};